/**
 * bundle-cart.js
 * Upload to: Assets/ in your Shopify theme
 * Add to theme.liquid <head>: {{ 'bundle-cart.js' | asset_url | script_tag }}
 *
 * 1. Removes orphaned bundle child items when the parent is removed
 * 2. Fires shapes:cart:update with correct sections payload so the
 *    Shapes theme cart count, drawer, and footer all update correctly
 */

(function () {
  'use strict';

  // ── Cart API ──────────────────────────────────────────────────────────────
  function getCart() {
    return fetch('/cart.js?_=' + Date.now(), {
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    }).then(function (r) { return r.json(); });
  }

  function removeByKeys(keys) {
    if (!keys || keys.length === 0) return Promise.resolve();
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    // Use sections param so Shopify returns updated section HTML in one request
    return fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        updates:      updates,
        sections:     'cart-items,cart-footer,cart-item-count,cart-live-region',
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); });
  }

  // ── Notify Shapes theme with the correct event format ────────────────────
  // From the theme JS (cart-count.js store):
  //   window.addEventListener('shapes:cart:update', (e) => {
  //     this._setFromFetchedSection(e.detail.response);  <-- needs sections
  //   })
  // The response needs: { sections: { 'cart-item-count': '<html>' } }
  function notifyShapesTheme(updateResponse) {
    window.dispatchEvent(new CustomEvent('shapes:cart:update', {
      bubbles: true,
      detail:  { response: updateResponse }
    }));
  }

  // ── Core: check cart for orphaned children and remove them ───────────────
  var checking = false;

  function checkOrphans() {
    if (checking) return;
    checking = true;

    getCart().then(function (cart) {
      checking = false;
      var items = cart.items || [];

      // Active bundle IDs = _bundle_id values that still have a parent
      // Parent = has _bundle_id but does NOT have _bundle property
      var activeBundleIds = {};
      items.forEach(function (item) {
        if (!item.properties) return;
        var bundleId = item.properties['_bundle_id'];
        var isChild  = !!item.properties['_bundle'];
        if (bundleId && !isChild) {
          activeBundleIds[bundleId] = true;
        }
      });

      // Orphans = children whose parent _bundle_id is gone from cart
      var orphanKeys = [];
      items.forEach(function (item) {
        if (!item.properties) return;
        var bundleId = item.properties['_bundle_id'];
        var isChild  = !!item.properties['_bundle'];
        if (bundleId && isChild && !activeBundleIds[bundleId]) {
          orphanKeys.push(item.key);
        }
      });

      if (orphanKeys.length === 0) return;

      console.log('[Bundle] Removing ' + orphanKeys.length + ' orphaned child item(s)');

      removeByKeys(orphanKeys).then(function (response) {
        // response from /cart/update.js includes sections when requested
        // Fire the Shapes theme event so count + drawer + footer all update
        notifyShapesTheme(response);
      });

    }).catch(function () {
      checking = false;
    });
  }

  // ── Listen for cart change events ────────────────────────────────────────
  // Intercept fetch calls to cart change/update/clear endpoints
  var debounceTimer = null;
  function scheduleCheck() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(checkOrphans, 500);
  }

  // Watch for Shapes theme cart events
  window.addEventListener('shapes:cart:cartqtychange', scheduleCheck);
  window.addEventListener('shapes:cart:update',        scheduleCheck);
  window.addEventListener('shapes:cart:afteradditem',  scheduleCheck);

  // Intercept fetch to catch Alpine-driven cart changes
  var origFetch = window.fetch;
  window.fetch = function (url) {
    var result = origFetch.apply(this, arguments);
    if (typeof url === 'string' && (
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear')  !== -1
    )) {
      // Don't re-trigger for our own orphan removal calls
      result.then(function (r) {
        if (!r._isBundleOrphanRemoval) scheduleCheck();
      });
    }
    return result;
  };

  // ── Init — clean up orphans on page load ──────────────────────────────────
  checkOrphans();

})();